import cx from 'classnames';
import { useController, useFormContext } from 'react-hook-form';

import { NumberInput } from '@flipster/ui';
import { inputFormatter } from '@flipster/utils/num';

import styles from './sendPriceInput.module.scss';

interface Props {
  name: string;
  currency: string;
  currencyClassName?: string;
  precision: number;
  max?: string;
  placeholder?: string;
}

const SendPriceInput = ({ name, precision, currency, max, placeholder = '0', currencyClassName }: Props) => {
  const { control, trigger } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name, control });

  const handleChange = (newValue: string) => {
    onChange(newValue);
    trigger(name);
  };

  return (
    <div className={styles.wrapper}>
      <NumberInput
        shape='inner'
        value={value}
        onChange={handleChange}
        currency={currency}
        precision={precision}
        className={styles.customInput}
        max={max}
        onBlur={() => {
          trigger(name);
        }}
      />
      <div className={cx(styles.fakeInput, { [styles.greaterThanZero]: Number(value) > 0 })}>
        {(!value || value === '0') && placeholder ? placeholder : inputFormatter(value, { withComma: true })}
        <span className={currencyClassName}>{currency}</span>
      </div>
    </div>
  );
};

export default SendPriceInput;
